import Button from "@mui/material/Button"
import { MenuItem, Grid2 as Grid } from "@mui/material"
import { Formik, Field } from "formik"
import { Produttore } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikTextField, FormikSelect } from "./formsHelpers"
import { FormInDialogProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { ACVocabolarioMulti } from "./autocompletes"
import VocaboloForm from "./VocaboloForm"
import { useVocabolarioCreate } from "../../hooks/vocabolari"

export default function ProduttoreForm({ item, save, ref, language }: FormInDialogProps<Produttore>) {
  const { t } = useTranslation()
  const { mutateAsync: createVocabolo } = useVocabolarioCreate()

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("produttore.nome")),
        tipologia: yup.string().required().label(t("produttore.tipologia")),
      }),
    [t]
  )

  const initialValues = useMemo(() => {
    return (
      item ?? {
        nome: "",
        tipologia: "",
        anno_inizio: "",
        anno_fine: "",
        funzioni: [],
        biografia: "",
      }
    )
  }, [item])

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Produttore).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue, setFieldTouched }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="cognome"
                  label={t("produttore.cognome")}
                  autoFocus
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("produttore.nome")}
                  autoFocus
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid size={4}>
                <Field
                  component={FormikSelect}
                  name="tipologia"
                  label={t("produttore.tipologia")}
                  required
                  fullWidth
                  margin="dense"
                  variant="outlined"
                >
                  <MenuItem value={"persona fisica"}>{t("produttore.enum_tipologia.persona_fisica")}</MenuItem>
                  <MenuItem value={"famiglia"}>{t("produttore.enum_tipologia.famiglia")}</MenuItem>
                  <MenuItem value={"ente"}>{t("produttore.enum_tipologia.ente")}</MenuItem>
                </Field>
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="biografia_it"
                    margin="dense"
                    label={t("produttore.biografia")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="biografia_en"
                    margin="dense"
                    label={t("produttore.biografia")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                )}
              </Grid>
              <Grid size={12}>
                <ACVocabolarioMulti
                  label={t("produttore.funzioni")}
                  vocabolario="funzioni"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  value={values.funzioni ?? []}
                  onChange={(value) => {
                    setFieldValue("funzioni", value)
                  }}
                  onBlur={() => {
                    setFieldTouched("funzioni", true)
                  }}
                  FormComponent={VocaboloForm}
                  formComponentProps={{ vocabolario: "funzioni" }}
                  create={createVocabolo}
                  initialCreate={(search) => ({ termine_it: search, vocabolario: "funzioni" })}
                />
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_it"
                    margin="dense"
                    label={t("produttore.note")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_en"
                    margin="dense"
                    label={t("produttore.note")}
                    fullWidth
                    multiline
                    minRows={6}
                    variant="outlined"
                  />
                )}
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
